export class CategoriesChildrenEntity {
  id: number;
  name: string;
  logo: string;
  checked?: boolean;
  constructor(categoriesChildrenEntity: object) {
    Object.assign(this, categoriesChildrenEntity);
  }
}
